import { gql } from '@apollo/client';

const ENROLL_PRECHARGEOFF_SETTLEMENT_OFFER = gql`
  mutation EnrollPrechargeoffSettlementOffer(
    $customerId: String!
    $accountId: String!
    $settlementBalance: Long!
    $originalOutstandingBalance: Long!
    $expirationDate: String!
    $dscName: String
    $offerTermsLabel: String
  ) {
    enrollPrechargeoffSettlementOffer(
      input: {
        customerId: $customerId
        accountId: $accountId
        settlementBalance: $settlementBalance
        originalOutstandingBalance: $originalOutstandingBalance
        expirationDate: $expirationDate
        dscName: $dscName
        offerTermsLabel: $offerTermsLabel
      }
      channel: AGENT_TOOL
    ) {
      offerId
      createdAt
      updatedAt
      data {
        offerId
        offerState
        customerId
        accountId
        originalOutstandingBalance
        settlementBalance
        remainingBalance
        expirationDate
        terminationReason
        dscName
        offerTermsLabel
        paymentPlanId
      }
    }
  }
`;

const CREATE_PRECHARGEOFF_SETTLEMENT_PAYMENT_PLAN = gql`
  mutation CreatePrechargeoffSettlementPaymentPlan(
    $offerId: UUID!
    $fundingAccountId: String!
    $authorizationText: String!
    $customerId: String!
    $transactions: [PrechargeoffSettlementTransactionInput!]!
  ) {
    createPrechargeoffSettlementPaymentPlan(
      offerId: $offerId
      input: {
        fundingAccountId: $fundingAccountId
        authorizationText: $authorizationText
        customerId: $customerId
        transactions: $transactions
      }
      channel: AGENT_TOOL
    ) {
      offerId
      createdAt
      updatedAt
      data {
        offerId
        offerState
        customerId
        accountId
        originalOutstandingBalance
        settlementBalance
        remainingBalance
        expirationDate
        paymentPlanId
      }
    }
  }
`;

const UPDATE_PRECO_PAYMENT_PLAN = gql`
  mutation UpdatePrecoPaymentPlan(
    $offerId: UUID!
    $transactions: [PrechargeoffSettlementTransactionInput!]!
    $authorizationText: String!
  ) {
    updatePrecoPaymentPlan(
      offerId: $offerId
      input: {
        transactions: $transactions
        authorizationText: $authorizationText
      }
      channel: AGENT_TOOL
    ) {
      offerId
      data {
        offerId
        offerState
        remainingBalance
        payments {
          txId
          type
          amount
          date
        }
      }
    }
  }
`;

const CALCULATE_PAYMENT_PLAN = gql`
  mutation CalculatePaymentPlan(
    $totalAmount: Int!
    $startDate: String
    $endDate: String!
    $cadence: PaymentPlanCadence!
  ) {
    calculatePaymentPlan(
      totalAmount: $totalAmount
      startDate: $startDate
      endDate: $endDate
      cadence: $cadence
    ) {
      startDate
      payments {
        amount
        date
      }
    }
  }
`;

const UPDATE_PRECO_FUNDING_ACCOUNT = gql`
  mutation UpdatePrecoFundingAccount(
    $offerId: UUID!
    $fundingAccountId: String!
    $authorizationText: String!
  ) {
    updatePrecoFundingAccount(
      offerId: $offerId
      input: {
        fundingAccountId: $fundingAccountId
        authorizationText: $authorizationText
      }
      channel: AGENT_TOOL
    ) {
      offerId
      data {
        offerId
        offerState
      }
    }
  }
`;

const CANCEL_PRECHARGEOFF_SETTLEMENT_PAYMENT_PLAN = gql`
  mutation CancelPrechargeoffSettlementPaymentPlan(
    $offerId: UUID!
    $canceledReason: PrechargeoffSettlementCanceledReason!
  ) {
    cancelPrechargeoffSettlementPaymentPlan(
      offerId: $offerId
      canceledReason: $canceledReason
      channel: AGENT_TOOL
    ) {
      offerId
      createdAt
      updatedAt
      data {
        offerId
        offerState
        paymentPlanId
      }
    }
  }
`;

const UNENROLL_PRECHARGEOFF_SETTLEMENT_OFFER = gql`
  mutation UnenrollPrechargeoffSettlementOffer($offerId: UUID!) {
    unenrollPrechargeoffSettlementOffer(offerId: $offerId) {
      offerId
      data {
        offerState
        terminationReason
      }
    }
  }
`;

export {
  ENROLL_PRECHARGEOFF_SETTLEMENT_OFFER,
  CREATE_PRECHARGEOFF_SETTLEMENT_PAYMENT_PLAN,
  UPDATE_PRECO_PAYMENT_PLAN,
  UPDATE_PRECO_FUNDING_ACCOUNT,
  CALCULATE_PAYMENT_PLAN,
  CANCEL_PRECHARGEOFF_SETTLEMENT_PAYMENT_PLAN,
  UNENROLL_PRECHARGEOFF_SETTLEMENT_OFFER,
};
